

















































































































import { Component, Vue ,Watch} from 'vue-property-decorator'
import {getUtilizationListRequest,getEnergyUtilizationRequest} from '@/api/enerySupervision'
import {getdDcryptUrlRequest} from '@/api/msgEnterprise'
import moment from 'moment'
@Component({
    components:{
    },
    filters: {
        statusFilter: (value: number) => {
            switch (value) {
                case 0:
                    return '未上传'
                    break
                case 1:
                    return '已上传'
                    break
                case 2:
                    return '已退回'
                    break
                case 3:
                    return '已确认'
                    break
                default:
                    return '未上传'
            } 
        },
        colorFilter: (value: number) => {
            switch (value) {
                case 0:
                    return 'red'
                    break
                case 1:
                    return 'green'
                    break
                case 2:
                    return 'green'
                    break
                case 3:
                    return 'green'
                    break
                default:
                    return 'red'
            } 
        },
    },
})

export default class Login  extends Vue {
    private modalBtnisshow:any=true
    private year:any=moment(new Date().getFullYear(), 'YYYY')
    private yearShowOne:boolean=false
    private visible:boolean= false
    private loading:boolean=false
    private loadingB:Boolean=false
    private visibleB:boolean= false
    private pdfUrl:string=''
    private value:string=''
    private data:any=[]
    private columns:any = [
    {
        title: '序号',
        dataIndex: 'fileType',
        width: 200,
    },
    {
        title: '名称',
        dataIndex: 'fileTypeName',
        width: 300,
    },
    {
        title: '上传状态',
        scopedSlots: { customRender: 'status' },
    },
        {
        title: '上传时间',
        dataIndex: 'reportTime',
    },
        {
        title: '操作',
        scopedSlots: { customRender: 'action' },
    }
    ];
    async getUtilizationList(code:any,time:any){
        const {status,data} = await getUtilizationListRequest({id:code,dataYear:time})
        this.data=data
        this.data.forEach((ele:any)=>{
            ele.key=ele.fileType
        })
    }
    async getdDcryptUrl(obsurl:any){
        const {status,data} = await getdDcryptUrlRequest({url:obsurl})
        this.pdfUrl=data

         if(this.pdfUrl){
            this.visible = true
        }else{
            this.$message.info('暂无文件')
        }
    }
    async getEnergyUtilization(code:any,time:any,val:any,statu:any){
        const {status,data} = await getEnergyUtilizationRequest({id:code,dataYear:time,reason:val,status:statu})
        if(status==0){
            this.$message.success('操作成功')
        }else{
            this.$message.error('操作失败')
        }
    }
    // 弹出日历和关闭日历的回调
    openChangeOne(status:any){
        if(status){
            this.yearShowOne =  true
        }
    }
    // 得到年份选择器的值
    onYearChange(value:any){
        this.year = moment(value).format('YYYY')
        this.yearShowOne = false
        this.getUtilizationList(this.$route.query.code,this.year)
    }
    async lookFile(e:any){
        await this.getdDcryptUrl(e.url) 
        if(e.isReport && e.status==1){
            this.modalBtnisshow=false
        }else{
            this.modalBtnisshow=true
        }
    }
    handleOk(e:any) {
        this.loading = true
        this.getEnergyUtilization(this.$route.query.code,this.year,this.value,1)
        setTimeout(() => {
            this.visible=false
            this.visible = false
            this.loading = false
            this.getUtilizationList(this.$route.query.code,this.year)
        }, 1000)
    }
    handleCancelB(e:any) {
        // 退回0，确认1
        this.visibleB=false
        this.value=''
    }
    handleOkB(e:any) {
        this.loadingB = true
        this.getEnergyUtilization(this.$route.query.code,this.year,this.value,0)
        setTimeout(() => {
            this.visible=false
            this.visibleB = false
            this.loadingB = false
            this.getUtilizationList(this.$route.query.code,this.year)
        }, 1000)
    }
    handleCancel(e:any) {
    //   this.visible = false
        this.visibleB=true
    }
    mounted(){
        if(this.$route.query.code){
            this.year=this.$route.query.year
            this.getUtilizationList(this.$route.query.code,this.year)
        }
    }
}
